import React, { useState, useEffect } from "react";
import Icon from "../../components/icon/Icon";
import axios from "axios";
import { baseURLs, units } from "../../utils/Constants";
import { getAxiosHeaders } from "../../utils/Utils";
import {
  Alert,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import { Empty, Input, Select, InputNumber, Divider, Form } from "antd";
import { Block } from "../../components/Component";
const { TextArea } = Input;

export const AddExpenseCategoryModal = ({
  businessID,
  currency,
  showModal,
  toggleModal,
  updateList,
  ...props
}) => {
  const [form] = Form.useForm();
  const [requesting, setRequesting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleFormSubmit = (_formData) => {
    setRequesting(true);
    setErrorMessage("");

    axios
      .post(
        baseURLs.API_URL + `/expenses/category`,
        {
          business_id: businessID,
          category_type: _formData.category_type,
          category_name: _formData.category_name,
        },
        getAxiosHeaders()
      )
      .then((response) => {
        form.resetFields();
        setRequesting(false);
        updateList(_formData.category_name);
      })
      .catch((error) => {
        try {
          let errorResponse = error.response.data;

          if (errorResponse.hasOwnProperty("errors")) {
            form.setFields([
              {
                name: "category_type",
                errors: errorResponse.errors.hasOwnProperty("category_type")
                  ? [errorResponse.errors.category_type]
                  : [],
              },
              {
                name: "category_name",
                errors: errorResponse.errors.hasOwnProperty("category_name")
                  ? [errorResponse.errors.category_name]
                  : [],
              },
            ]);
          }

          let errorMessage = "Error: Could not connect to server";
          if (errorResponse.hasOwnProperty("error")) {
            errorMessage = errorResponse.error;
          }

          setErrorMessage(errorMessage);
          setRequesting(false);
        } catch (e) {
          setErrorMessage("Error: Could not connect to server");
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal backdrop="static" isOpen={showModal} id="create_material_modal">
      <ModalHeader
        toggle={toggleModal}
        close={
          <button className="close" disabled={requesting} onClick={toggleModal}>
            <Icon name="cross" />
          </button>
        }
      >
        Add a New Expense Category
      </ModalHeader>
      <Form
        name="add-raw-material"
        form={form}
        className="is-alter"
        initialValues={{
          category_name: "",
          category_type: "",
        }}
        onFinish={handleFormSubmit}
        onFinishFailed={onFinishFailed}
      >
        <ModalBody>
          {errorMessage && (
            <div className="mb-3">
              <Alert color="danger" className="alert-icon">
                {" "}
                <Icon name="alert-circle" /> {errorMessage}{" "}
              </Alert>
            </div>
          )}

          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <Form.Item>
                  <div className="form-label-group">
                    <label className="form-label">
                      Category Type <span className="text-danger">*</span>
                    </label>
                  </div>
                  <Form.Item
                    name={"category_type"}
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: "category type is required",
                      },
                    ]}
                  >
                    <Select
                      size="large"
                      placeholder="Select a category type"
                      style={{ width: "100%" }}
                      options={[
                        {
                          value: "Cost of Goods Sold",
                          label: "Cost of Goods Sold",
                        },
                        {
                          value: "Operating Expenses",
                          label: "Operating Expenses",
                        },
                        {
                          value: "Capital Expenditures",
                          label: "Capital Expenditures",
                        },
                      ]}
                      filterOption={(inputValue, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) !== -1
                      }
                      showSearch
                      allowClear
                    />
                  </Form.Item>
                </Form.Item>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <Form.Item>
                  <div className="form-label-group">
                    <label className="form-label">
                      Category Name <span className="text-danger">*</span>
                    </label>
                  </div>
                  <Form.Item
                    name={"category_name"}
                    noStyle
                    rules={[{ required: true }]}
                  >
                    <Input
                      size="large"
                      className="form-control form-control-lg"
                      placeholder="Enter category name"
                    />
                  </Form.Item>
                </Form.Item>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="bg-lighter justify-content-center">
          <Button
            disabled={requesting}
            type="submit"
            color="primary"
            size="md"
            className="btn-mw m-1"
          >
            {requesting ? <Spinner size="sm" color="light" /> : "Submit"}
          </Button>
          <Button
            disabled={requesting}
            color="light"
            size="md"
            className="btn-mw m-1"
            onClick={toggleModal}
          >
            Close
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export const EditExpenseCategoryModal = ({
  businessID,
  currency,
  showModal,
  toggleModal,
  category,
  updateList,
  ...props
}) => {
  const [form] = Form.useForm();
  const [requesting, setRequesting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleFormSubmit = (_formData) => {
    setRequesting(true);
    setErrorMessage("");

    axios
      .put(
        baseURLs.API_URL + `/expenses/category/${category.category_id}`,
        {
          business_id: businessID,
          category_type: _formData.category_type,
          category_name: _formData.category_name,
        },
        getAxiosHeaders()
      )
      .then((response) => {
        form.resetFields();
        setRequesting(false);
        updateList();
      })
      .catch((error) => {
        try {
          let errorResponse = error.response.data;

          if (errorResponse.hasOwnProperty("errors")) {
            form.setFields([
              {
                name: "category_type",
                errors: errorResponse.errors.hasOwnProperty("category_type")
                  ? [errorResponse.errors.category_type]
                  : [],
              },
              {
                name: "category_name",
                errors: errorResponse.errors.hasOwnProperty("category_name")
                  ? [errorResponse.errors.category_name]
                  : [],
              },
            ]);
          }

          let errorMessage = "Error: Could not connect to server";
          if (errorResponse.hasOwnProperty("error")) {
            errorMessage = errorResponse.error;
          }

          setErrorMessage(errorMessage);
          setRequesting(false);
        } catch (e) {
          setErrorMessage("Error: Could not connect to server");
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal backdrop="static" isOpen={showModal} id="create_material_modal">
      <ModalHeader
        toggle={toggleModal}
        close={
          <button className="close" disabled={requesting} onClick={toggleModal}>
            <Icon name="cross" />
          </button>
        }
      >
        Edit Expense Category
      </ModalHeader>
      <Form
        name="add-raw-material"
        form={form}
        className="is-alter"
        initialValues={{
          category_name: category.category_name,
          category_type: category.category_type,
        }}
        onFinish={handleFormSubmit}
        onFinishFailed={onFinishFailed}
      >
        <ModalBody>
          {errorMessage && (
            <div className="mb-3">
              <Alert color="danger" className="alert-icon">
                {" "}
                <Icon name="alert-circle" /> {errorMessage}{" "}
              </Alert>
            </div>
          )}

          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <Form.Item>
                  <div className="form-label-group">
                    <label className="form-label">
                      Category Type <span className="text-danger">*</span>
                    </label>
                  </div>
                  <Form.Item
                    name={"category_type"}
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: "category type is required",
                      },
                    ]}
                  >
                    <Select
                      size="large"
                      placeholder="Select a category type"
                      style={{ width: "100%" }}
                      options={[
                        {
                          value: "Cost of Goods Sold",
                          label: "Cost of Goods Sold",
                        },
                        {
                          value: "Operating Expenses",
                          label: "Operating Expenses",
                        },
                        {
                          value: "Capital Expenditures",
                          label: "Capital Expenditures",
                        },
                      ]}
                      filterOption={(inputValue, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) !== -1
                      }
                      showSearch
                      allowClear
                    />
                  </Form.Item>
                </Form.Item>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <Form.Item>
                  <div className="form-label-group">
                    <label className="form-label">
                      Category Name <span className="text-danger">*</span>
                    </label>
                  </div>
                  <Form.Item
                    name={"category_name"}
                    noStyle
                    rules={[{ required: true }]}
                  >
                    <Input
                      size="large"
                      className="form-control form-control-lg"
                      placeholder="Enter category name"
                    />
                  </Form.Item>
                </Form.Item>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="bg-lighter justify-content-center">
          <Button
            disabled={requesting}
            type="submit"
            color="primary"
            size="md"
            className="btn-mw m-1"
          >
            {requesting ? <Spinner size="sm" color="light" /> : "Submit"}
          </Button>
          <Button
            disabled={requesting}
            color="light"
            size="md"
            className="btn-mw m-1"
            onClick={toggleModal}
          >
            Close
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export const MergeExpenseCategoryModal = ({
  businessID,
  currency,
  showModal,
  toggleModal,
  fromCategory,
  updateList,
  ...props
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [requesting, setRequesting] = useState(false);
  const [categories, setCategories] = useState([]);
  const [deleteFromCategoryCheck, setDeleteFromCategoryCheck] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleFormSubmit = (_formData) => {
    setRequesting(true);
    setErrorMessage("");

    axios
      .put(
        baseURLs.API_URL + `/expenses/merge-category`,
        {
          business_id: businessID,
          from_category: _formData.from_category,
          to_category: _formData.to_category,
          delete_from_category: _formData.delete_from_category ? "yes" : "no",
        },
        getAxiosHeaders()
      )
      .then((response) => {
        form.resetFields();
        setRequesting(false);
        updateList();
      })
      .catch((error) => {
        try {
          let errorResponse = error.response.data;

          if (errorResponse.hasOwnProperty("errors")) {
            form.setFields([
              {
                name: "from_category",
                errors: errorResponse.errors.hasOwnProperty("from_category")
                  ? [errorResponse.errors.from_category]
                  : [],
              },
              {
                name: "to_category",
                errors: errorResponse.errors.hasOwnProperty("to_category")
                  ? [errorResponse.errors.to_category]
                  : [],
              },
            ]);
          }

          let errorMessage = "Error: Could not connect to server";
          if (errorResponse.hasOwnProperty("error")) {
            errorMessage = errorResponse.error;
          }

          setErrorMessage(errorMessage);
          setRequesting(false);
        } catch (e) {
          setErrorMessage("Error: Could not connect to server");
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    console.log("Failed:", errorInfo);
  };

  const sortByCategoryTypeAndCategory = (arr) => {
    return arr.sort((a, b) => {
      // First, sort by category_type
      if (a.category_type !== b.category_type) {
        return a.category_type.localeCompare(b.category_type);
      }
      // If category_type is the same, sort by category
      return a.category.localeCompare(b.category);
    });
  };

  const getExpensesCategory = (businessID) => {
    return axios
      .get(baseURLs.API_URL + "/expenses/category", {
        params: {
          business_id: businessID,
          limit: 500,
        },
        headers: getAxiosHeaders().headers,
      })
      .then((response) => {
        let responseInfo = response.data;
        let categories = responseInfo.data.categories;
        const sortedCategory = sortByCategoryTypeAndCategory(categories);
        setCategories([...sortedCategory]);
        setLoading(false);
      })
      .catch((error) => {
        try {
          let errorResponse = error.response.data;

          let errorMessage = "Error: Could not connect to server";
          if (errorResponse.hasOwnProperty("error")) {
            errorMessage = errorResponse.error;
          }
        } catch (e) {
          console.log(e);
          // history.push(`${process.env.PUBLIC_URL}/server-offline`);
        }

        setLoading(false);
      });
  };

  const groupedCategories = categories.reduce((acc, category) => {
    if (!acc[category.category_type_name]) {
      acc[category.category_type_name] = [];
    }
    acc[category.category_type_name].push(category);
    return acc;
  }, {});

  const fromSelectOptions = Object.entries(groupedCategories).map(
    ([type, categories]) => ({
      label: type,
      options: categories.map((cat) => ({
        label: cat.category,
        value: cat.category,
      })),
    })
  );

  const toSelectOptions = Object.entries(groupedCategories).map(
    ([type, categories]) => ({
      label: type,
      options: categories.map((cat) => ({
        label: cat.category,
        value: cat.category,
        disabled: cat.category === fromCategory.category_name,
      })),
    })
  );

  useEffect(() => {
    getExpensesCategory(businessID);
  }, []);

  return (
    <Modal backdrop="static" isOpen={showModal} id="create_material_modal">
      <ModalHeader
        toggle={toggleModal}
        close={
          <button className="close" disabled={requesting} onClick={toggleModal}>
            <Icon name="cross" />
          </button>
        }
      >
        Merge Expense Category
      </ModalHeader>
      {loading ? (
        <Block className="nk-block-middle nk-auth-body text-center wide-xs">
          <div className="inner-pre-loader">
            <Spinner color="dark" />
          </div>
        </Block>
      ) : (
        <Form
          name="add-raw-material"
          form={form}
          className="is-alter"
          initialValues={{
            from_category: fromCategory.category_name,
            to_category: "",
            delete_from_category: false,
          }}
          onFinish={handleFormSubmit}
          onFinishFailed={onFinishFailed}
        >
          <ModalBody>
            {errorMessage && (
              <div className="mb-3">
                <Alert color="danger" className="alert-icon">
                  {" "}
                  <Icon name="alert-circle" /> {errorMessage}{" "}
                </Alert>
              </div>
            )}

            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <Form.Item>
                    <div className="form-label-group">
                      <label className="form-label">
                        From Category <span className="text-danger">*</span>
                      </label>
                    </div>
                    <Form.Item
                      name={"from_category"}
                      noStyle
                      rules={[
                        {
                          required: true,
                          message: "Quantity is required",
                        },
                      ]}
                    >
                      <Select
                        className="select-tags"
                        size="large"
                        disabled={true}
                        placeholder="Select category"
                        style={{ width: "100%" }}
                        options={fromSelectOptions}
                        popupMatchSelectWidth={false}
                      />
                    </Form.Item>
                  </Form.Item>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <Form.Item>
                    <div className="form-label-group">
                      <label className="form-label">
                        To Category <span className="text-danger">*</span>
                      </label>
                    </div>
                    <Form.Item
                      name={"to_category"}
                      noStyle
                      rules={[
                        {
                          required: true,
                          message: "Category is required",
                        },
                      ]}
                    >
                      <Select
                        className="select-tags"
                        size="large"
                        placeholder="Select category"
                        style={{ width: "100%" }}
                        options={toSelectOptions}
                        popupMatchSelectWidth={false}
                        filterOption={(inputValue, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(inputValue.toLowerCase()) !== -1
                        }
                        showSearch
                      />
                    </Form.Item>
                  </Form.Item>
                </div>
              </div>
              <div className="col-md-12">
                <Form.Item name="delete_from_category" valuePropName="checked">
                  <div className="form-group">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        checked={deleteFromCategoryCheck}
                        onChange={() => {
                          setDeleteFromCategoryCheck(!deleteFromCategoryCheck);
                          form.setFieldValue(
                            "delete_from_category",
                            !deleteFromCategoryCheck
                          );
                        }}
                        id="delete_from_category"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="delete_from_category"
                      >
                        Delete <b>{fromCategory.category_name}</b> category
                      </label>
                    </div>
                  </div>
                </Form.Item>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="bg-lighter justify-content-center">
            <Button
              disabled={requesting}
              type="submit"
              color="primary"
              size="md"
              className="btn-mw m-1"
            >
              {requesting ? <Spinner size="sm" color="light" /> : "Submit"}
            </Button>
            <Button
              disabled={requesting}
              color="light"
              size="md"
              className="btn-mw m-1"
              onClick={toggleModal}
            >
              Close
            </Button>
          </ModalFooter>
        </Form>
      )}
    </Modal>
  );
};
